import { apiGet } from "./api";

export const getBenefits = async (params: any) => {
    const queryString = {
        action: 'get_all_benefits',
        ...params
    };
    const { data } = await apiGet(queryString);
    return data;
}